import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { ShieldCheck, TrendingUp } from 'lucide-react';
export function SocialProof() {
  return <Section className="relative" data-id="element-227">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-brand-cyan/10 blur-[120px] -z-10 pointer-events-none" data-id="element-228" />

      <motion.div className="max-w-4xl mx-auto glass-card p-8 md:p-12 rounded-3xl border-brand-cyan/50 shadow-[0_0_50px_rgba(0,240,255,0.15)] relative overflow-hidden" initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} data-id="element-229">
        <div className="absolute top-0 right-0 p-8 opacity-10" data-id="element-230">
          <TrendingUp size={120} data-id="element-231" />
        </div>

        <div className="flex items-center gap-4 mb-8 relative z-10" data-id="element-232">
          <div className="p-3 bg-brand-cyan/20 rounded-xl text-brand-cyan" data-id="element-233">
            <ShieldCheck size={32} data-id="element-234" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-235">
            Resultados Garantizados
          </h2>
        </div>

        <p className="text-xl md:text-2xl text-white/90 leading-relaxed relative z-10 font-light" data-id="element-236">
          En los próximos 7 días, pasarás de tener una cuenta vacía a tener una
          presencia de marca con estética de nivel profesional, publicando
          diariamente contenido que la gente compartirá porque se siente{' '}
          <strong className="text-brand-cyan font-bold" data-id="element-237">"pro"</strong>, no
          artificial.
          <br data-id="element-238" />
          <br data-id="element-239" />
          El mercado hispano está saturado de mala calidad;{' '}
          <span className="text-brand-purpleLight font-semibold" data-id="element-240">
            tu marca Ghost destacará instantáneamente por su coherencia y
            diseño.
          </span>
        </p>
      </motion.div>
    </Section>;
}